module.exports = __webpack_public_path__ + "img/7-3.6ad97e52.png";